import React from 'react';
import HeaderController from '../components/Headers/HeaderController';
import ServerError from '../components/ServerError/ServerError';
import LoadingModal from '../components/Modals/LoadingModal/LoadingModal';
import StickyNotification from '../components/StickyNotification/StickyNotification';
import Footer from '../components/Footer/Footer';
import { useAppContext } from '../providers/AppProvider';
import { useParams } from 'react-router-dom';

type Props = {
    children: React.ReactNode;
    showHeaderSteps?: boolean;
    headerStage?: string;
    showFooter?: boolean;
};

const FunnelLayout: React.FC<Props> = ({ children, showHeaderSteps = true, showFooter = true, headerStage = "Payment" }) => {
    // Get the state and functions from AppContext
    const {
        isLoading,
        errorStatus,
        stickyNotification,
        setStickyNotification,
        headerVersion,
        hideHeaderSteps,
        hideHeader,
        useWhitePageBackground,
        hideFooter
    } = useAppContext();

    // Get language from route params
    const { language } = useParams<{ language: string }>();


    // Error 
    if (errorStatus) {
        return (
            <>
                <HeaderController showSteps={false} stage={"Questionnaire"} headerVersion={headerVersion} />
                <ServerError status={errorStatus} />
            </>
        );
    }

    // Children 
    return (
        <>
            <StickyNotification
                showNotification={stickyNotification.show}
                title={stickyNotification.title}
                content={stickyNotification.content}
                level={stickyNotification.level}
                onClick={() => setStickyNotification({ ...stickyNotification, show: false })}
                showInfoIcon={stickyNotification.showInfoIcon}
                refresh={stickyNotification.refresh}
                autoFade={stickyNotification.autoFade}
            />

            {isLoading && <LoadingModal />}
            
            <main id="page-container" className="relative flex flex-col min-h-screen">
                {!hideHeader && <HeaderController showSteps={showHeaderSteps && !hideHeaderSteps} stage={headerStage} headerVersion={headerVersion} />}
                <section id="page-content-container" className={`${errorStatus ? 'bg-white' : useWhitePageBackground ? 'bg-[#FDFCF9]' : 'bg-[#F7F7F7]'} flex-1 flex justify-center`}>
                    <div id="page-content" className="flex flex-col items-center w-full pt-[30px] md:pt-[60px] pb-[90px] px-[15px]">
                        {children}
                        
                        {/* Footer  */}
                        <div id='page-footer' className='mt-8 mb-8 md:mb-0 w-full'>
                            {!isLoading && showFooter && !hideFooter ? <Footer page="Shipping" language={language ?? 'de'} /> : null}
                        </div>
                    </div>
                </section>
            </main>

        </>
    );
};

export default FunnelLayout;
